module.exports = __webpack_public_path__ + "img/page2-5.4cbc9d60.png";